/**
 * 🏷 商品 Hub (v3.3 IA 刷新)
 *
 * 統合対象:
 *   - master.products (商品マスター)
 *   - master.product-bundles (セット商品)
 *   - sales.commissions (報酬設定 — v3.2.20 で master へ移動済)
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { ProductCatalogsPage } from '@/pages/products/ProductCatalogsPage';
import { ProductBundlesListPage } from '@/pages/product-bundles/ProductBundlesListPage';
import { CommissionsListPage } from '@/pages/commissions/CommissionsListPage';

const TABS: TabSpec[] = [
  { tabKey: 'catalogs',    label: '商品',       featureId: 'master.products',        render: () => <ProductCatalogsPage /> },
  { tabKey: 'bundles',     label: 'セット商品', featureId: 'master.product-bundles', render: () => <ProductBundlesListPage /> },
  { tabKey: 'commissions', label: '報酬設定',   featureId: 'sales.commissions',      render: () => <CommissionsListPage /> },
];

export function MasterProductsHubPage() {
  return <HubTabs tabs={TABS} defaultTab="catalogs" />;
}
